import React, { forwardRef, useImperativeHandle } from 'react';
import Chip from '@mui/material/Chip';
import LinearProgress from '@mui/material/LinearProgress';
import { Modal, Box, Button, Typography } from '@mui/material';

const Step4 = forwardRef((props, ref) => {
  const [portrait, setPortrait] = React.useState(false);
  const [accesoCamaraVerificada, setAccesoCamaraVerificada] = React.useState(null);
  const [funcionamientoCamara, setFuncionamientoCamara] = React.useState(null);
  const [mostrarCamaraModal, setMostrarCamaraModal] = React.useState(false);
  const [porcentajeAvanceCamaraFuncionamiento, setPorcentajeAvanceCamaraFuncionamiento] = React.useState(0);
  const [resolucionesCamara, setResolucionesCamara] = React.useState(null);
  const [resolucionQVGACamara, setResolucionQVGACamara] = React.useState(null);
  const [resolucionVGACamara, setResolucionVGACamara] = React.useState(null);
  const [resolucionHDCamara, setResolucionHDCamara] = React.useState(null);
  const [resolucionFullHDCamara, setResolucionFullHDCamara] = React.useState(null);
  const [resolucion2kCamara, setResolucion2kCamara] = React.useState(null);
  const [resolucion4kCamara, setResolucion4kCamara] = React.useState(null);
  const [mostrarMensajeModal, setMostrarMensajeModal] = React.useState(false);
  const [mostrarBotonContinuarModal, setMostrarBotonContinuarModal] = React.useState(false);
  const [mostrarBotonReintentarModal, setMostrarBotonReintentarModal] = React.useState(false);
  const [contenidoMensajeModal, setContenidoMensajeModal] = React.useState("");
  const videoRef = React.useRef(null);

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 200,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  useImperativeHandle(ref, () => ({
    // Funciones visibles por otros componentes.
    getAccesoCamaraVerificado() {
      return accesoCamaraVerificada
    },
    getFuncionamientoCamara() {
      return funcionamientoCamara
    },
    getResolucionesCamara() {
      return resolucionesCamara
    },
    getResolucionQVGACamara() {
      return resolucionQVGACamara
    },
    getResolucionVGACamara() {
      return resolucionVGACamara
    },
    getResolucionHDCamara() {
      return resolucionHDCamara
    },
    getResolucionFullHDCamara() {
      return resolucionFullHDCamara
    },
    getResolucionFull2kCamara() {
      return resolucion2kCamara
    },
    getResolucionFull4kCamara() {
      return resolucion4kCamara
    }
  }));

  const verificarAccesoCamara = (callback) => {
    navigator.mediaDevices.getUserMedia({ video: true })
    .then(function(stream) {
      console.log("Cámara verificada");
      console.log(stream);
      setAccesoCamaraVerificada(true);
      stream.getTracks().forEach(track => track.stop());
      callback(true);
    })
    .catch(function(error) {
      setAccesoCamaraVerificada(false);
      console.log("Nombre de error original: " + error.name);
      console.log("Mensaje de error original: " + error.message);
      if (error.name === 'NotAllowedError') {
        console.error('El usuario denegó el acceso a los dispositivos de medios.');
      } else if (error.name === 'NotFoundError' || error.name === 'DevicesNotFoundError') {
        console.error('No se encontraron dispositivos de medios compatibles.');
      } else if (error.name === 'NotReadableError' || error.name === 'TrackStartError') {
        console.error('No se puede acceder a los dispositivos de medios o el flujo de medios se ha detenido.');
      } else if (error.name === 'OverconstrainedError' || error.name === 'ConstraintNotSatisfiedError') {
        console.error('Las restricciones especificadas no pudieron ser satisfechas.');
      } else if (error.name === 'AbortError') {
        console.error('La operación fue abortada, posiblemente debido a una llamada a mediaDevices.getUserMedia() mientras otra llamada está en curso.');
      } else {
        console.error('Se produjo un error al obtener acceso a los dispositivos de medios:', error.name, error.message);
      }
      callback(false);
    });
  }

  const verificarFuncionamientoCamara = (callback) => {
    navigator.mediaDevices.getUserMedia({ video: true })
    .then(function(stream) {
      setMostrarCamaraModal(true);
      setTimeout(function() {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          
          let esTodoNegro = true;
          setTimeout(function() {
            let video = videoRef.current;
            let canvas = document.createElement('canvas');
            canvas.width = 40;
            canvas.height = 40;
            let ctx = canvas.getContext('2d');
            if (ctx != null && video != null) {
              console.log(ctx);
              ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
              let imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
              let data = imageData.data;
              
              
              for (let i = 0; i < data.length; i += 4) {
                // Comprueba si todos los píxeles están en negro (todos los componentes RGB son 0)
                if (data[i] !== 0 || data[i + 1] !== 0 || data[i + 2] !== 0) {
                  esTodoNegro = false;
                  break;
                }
              }
            }
          }, 2000);

          const idIntervalo = setInterval(function() {
            setPorcentajeAvanceCamaraFuncionamiento(porcentajeAvanceCamaraFuncionamiento => {
              if (porcentajeAvanceCamaraFuncionamiento >= 100) {
                clearInterval(idIntervalo);
                if (esTodoNegro) {
                  console.log("¡Todos los píxeles están en negro!");
                  setFuncionamientoCamara(false);
                  stream.getTracks().forEach(track => track.stop());
                  callback(false);
                } else {
                  console.log("¡No todos los píxeles están en negro!");
                  setFuncionamientoCamara(true);
                  stream.getTracks().forEach(track => track.stop());
                  callback(true);
                }
                return 100;
              }
              return porcentajeAvanceCamaraFuncionamiento + 10}
            );
          }, 300);
        }
      }, 1000);
    })
    .catch(function(error) {
      setFuncionamientoCamara(false);
      callback(false);
    });
  }
  
  const verificarResolucionesCamara = (callback) => {
    navigator.mediaDevices.getUserMedia({ video: true })
    .then(function(stream) {
      const track = stream.getVideoTracks()[0];
      const capabilities = track.getCapabilities();
      if (capabilities != null) {
        setResolucionesCamara(capabilities.width.min + "x" + capabilities.height.min + " a " + capabilities.width.max + "x" + capabilities.height.max);
        stream.getTracks().forEach(track => track.stop());
        callback(true);
      } else {
        setResolucionesCamara("");
        stream.getTracks().forEach(track => track.stop());
        callback(false);
      }
      track.stop();
    })
    .catch(function(error) {
      setResolucionesCamara("");
    });
  }

  const verificarResolucionQVGACamara = () => {
    let width = 320;
    let height = 240;
    if (portrait) {
      width = 240;
      height = 320;
    }
    navigator.mediaDevices.getUserMedia({ video: { width: width, height: height } })
    .then(function(stream) {
      stream.getTracks().forEach(track => track.stop());
      setResolucionQVGACamara(true);
    })
    .catch(function(error) {
      setResolucionQVGACamara(false);
    });
  }

  const verificarResolucionVGACamara = () => {
    let width = 640;
    let height = 480;
    if (portrait) {
      width = 480;
      height = 640;
    }
    navigator.mediaDevices.getUserMedia({ video: { width: width, height: height } })
    .then(function(stream) {
      stream.getTracks().forEach(track => track.stop());
      setResolucionVGACamara(true);
    })
    .catch(function(error) {
      setResolucionVGACamara(false);
    });
  }

  const verificarResolucionHDCamara = () => {
    let width = 1280;
    let height = 720;
    if (portrait) {
      width = 720;
      height = 1280;
    }
    navigator.mediaDevices.getUserMedia({ video: { width: width, height: height } })
    .then(function(stream) {
      stream.getTracks().forEach(track => track.stop());
      setResolucionHDCamara(true);
    })
    .catch(function(error) {
      setResolucionHDCamara(false);
    });
  }

  const verificarResolucionFullHDCamara = () => {
    let width = 1920;
    let height = 1080;
    if (portrait) {
      width = 1080;
      height = 1920;
    }
    navigator.mediaDevices.getUserMedia({ video: { width: width, height: height } })
    .then(function(stream) {
      stream.getTracks().forEach(track => track.stop());
      setResolucionFullHDCamara(true);
    })
    .catch(function(error) {
      setResolucionFullHDCamara(false);
    });
  }

  const verificarResolucion2kCamara = () => {
    let width = 2560;
    let height = 1440;
    if (portrait) {
      width = 1440;
      height = 2560;
    }
    navigator.mediaDevices.getUserMedia({ video: { width: width, height: height } })
    .then(function(stream) {
      stream.getTracks().forEach(track => track.stop());
      setResolucion2kCamara(true);
    })
    .catch(function(error) {
      setResolucion2kCamara(false);
    });
  }

  const verificarResolucion4kCamara = () => {
    let width = 3840;
    let height = 2160;
    if (portrait) {
      width = 2160;
      height = 3840;
    }
    navigator.mediaDevices.getUserMedia({ video: { width: width, height: height } })
    .then(function(stream) {
      stream.getTracks().forEach(track => track.stop());
      setResolucion4kCamara(true);
    })
    .catch(function(error) {
      setResolucion4kCamara(false);
    });
  }

  const cerrarModal = () => {
    setMostrarMensajeModal(false);
    setContenidoMensajeModal("");
  };

  const avanzar = () => {
    props.handleNext(4);
  };

  const init = () => {
    const mediaQuery = window.matchMedia("(orientation: portrait)");
    if (mediaQuery.matches) {
      setPortrait(true);
    } else {
      setPortrait(false);
    }
    setMostrarMensajeModal(false);
    setContenidoMensajeModal("");
    verificarAccesoCamara(function(resultadoAccesoCamara) {
      if (resultadoAccesoCamara) {
        verificarFuncionamientoCamara(function(resultadoFuncionamientoCamara) {
          const track = videoRef.current.srcObject.getVideoTracks()[0];
          track.stop();
          setMostrarCamaraModal(false);
          verificarResolucionesCamara(function(resolucionesDetectadas) {
            verificarResolucionQVGACamara();
            verificarResolucionVGACamara();
            verificarResolucionHDCamara();
            verificarResolucionFullHDCamara();
            verificarResolucion2kCamara();
            verificarResolucion4kCamara();
            setTimeout(function() {
              if (resultadoFuncionamientoCamara && resolucionesDetectadas) {
                setMostrarMensajeModal(true);
                setMostrarBotonContinuarModal(true);
                setMostrarBotonReintentarModal(false);
                setContenidoMensajeModal("Perfecto. Tu cámara está lista.");
              } else {
                setMostrarMensajeModal(true);
                setMostrarBotonContinuarModal(false);
                setMostrarBotonReintentarModal(true);
                setContenidoMensajeModal("No podemos determinar que tu cámara funcione bien.");
              }
            }, 1000);
          });
        });
      } else {
        setFuncionamientoCamara(false);
        verificarResolucionesCamara();
        setResolucionQVGACamara(false);
        setResolucionVGACamara(false);
        setResolucionHDCamara(false);
        setResolucionFullHDCamara(false);
        setResolucion2kCamara(false);
        setResolucion4kCamara(false);
        setTimeout(function() {
          setMostrarMensajeModal(true);
          setMostrarBotonContinuarModal(false);
          setMostrarBotonReintentarModal(true);
          setContenidoMensajeModal("No podemos acceder a tu cámara.");
        }, 1000);
      }
    });
  }

  React.useEffect(() => {
    init();
  }, []);

  return (
    <div style={{ minHeight: "70vh" }}>
      <h2>Verificación de cámara</h2>
      <div style={{ marginBottom: "20px", padding: "10px", borderTop: "1px solid lightGray", borderBottom: "1px solid lightGray" }}>
        <div style={{ textAlign: "left", fontSize: "18px", marginBottom: "5px" }}>Acceso:</div>
        {accesoCamaraVerificada != null ? accesoCamaraVerificada ? <Chip label="Ok, perfecto." color="success" />: <Chip label="No se pudo acceder" color="error" /> : <Chip label="?" color="warning" />}
      </div>
      <div style={{ marginBottom: "20px", padding: "10px", borderTop: "1px solid lightGray", borderBottom: "1px solid lightGray" }}>
        <div style={{ textAlign: "left", fontSize: "18px", marginBottom: "5px" }}>Funcionamiento:</div>
        {funcionamientoCamara != null ? funcionamientoCamara ? <Chip label="Ok, perfecto." color="success" />: <Chip label="No funciona correctamente" color="error" /> : <Chip label="?" color="warning" />}
      </div>
      <div>
        {mostrarCamaraModal ? <video style={{ marginRight: '10px' }} autoPlay={true} width={320} height={240} ref={videoRef}></video> : <span></span>}
        {mostrarCamaraModal ? <LinearProgress color="success" variant="determinate" value={porcentajeAvanceCamaraFuncionamiento} /> : <span></span>}
      </div>
      <div style={{ padding: "10px", borderTop: "1px solid lightGray", textAlign: "left" }}>
        <div style={{ textAlign: "left", fontSize: "14px", marginBottom: "5px", display: "inline", lineHeight: "32px" }}>Resoluciones:</div>
        <span style={{ float: "right" }}>
          {resolucionesCamara != null ? resolucionesCamara != "" ? <Chip label={resolucionesCamara} color="success" /> : <Chip label="Sin resoluciones detectadas" color="error" /> : <Chip label="?" color="warning" />}
        </span>
      </div>
      <div style={{ padding: "10px", borderTop: "1px solid lightGray", textAlign: "left" }}>
        <div style={{ textAlign: "left", fontSize: "14px", marginBottom: "5px", display: "inline", lineHeight: "32px" }}>Resolución QVGA:</div>
        <span style={{ float: "right" }}>
          {resolucionQVGACamara != null ? resolucionQVGACamara ? <Chip label="Ok, perfecto." color="success" /> : <Chip label="Sin acceso" color="error" /> : <Chip label="?" color="warning" />}
        </span>
      </div>
      <div style={{ padding: "10px", borderTop: "1px solid lightGray", textAlign: "left" }}>
        <div style={{ textAlign: "left", fontSize: "14px", marginBottom: "5px", display: "inline", lineHeight: "32px" }}>Resolución VGA:</div>
        <span style={{ float: "right" }}>
        {resolucionVGACamara != null ? resolucionVGACamara ? <Chip label="Ok, perfecto." color="success" /> : <Chip label="Sin acceso" color="error" /> : <Chip label="?" color="warning" />}
        </span>
      </div>
      <div style={{ padding: "10px", borderTop: "1px solid lightGray", textAlign: "left" }}>
        <div style={{ textAlign: "left", fontSize: "14px", marginBottom: "5px", display: "inline", lineHeight: "32px" }}>Resolución HD:</div>
        <span style={{ float: "right" }}>
          {resolucionHDCamara != null ? resolucionHDCamara ? <Chip label="Ok, perfecto." color="success" /> : <Chip label="Sin acceso" color="error" /> : <Chip label="?" color="warning" />}
        </span>
      </div>
      <div style={{ padding: "10px", borderTop: "1px solid lightGray", textAlign: "left" }}>
        <div style={{ textAlign: "left", fontSize: "14px", marginBottom: "5px", display: "inline", lineHeight: "32px" }}>Resolución Full HD:</div>
        <span style={{ float: "right" }}>
          {resolucionFullHDCamara != null ? resolucionFullHDCamara ? <Chip label="Ok, perfecto." color="success" /> : <Chip label="Sin acceso" color="error" /> : <Chip label="?" color="warning" />}
        </span>
      </div>
      <div style={{ padding: "10px", borderTop: "1px solid lightGray", textAlign: "left" }}>
        <div style={{ textAlign: "left", fontSize: "14px", marginBottom: "5px", display: "inline", lineHeight: "32px" }}>Resolución 2K:</div>
        <span style={{ float: "right" }}>
          {resolucion2kCamara != null ? resolucion2kCamara ? <Chip label="Ok, perfecto." color="success" /> : <Chip label="Sin acceso" color="error" /> : <Chip label="?" color="warning" />}
        </span>
      </div>
      <div style={{ padding: "10px", borderTop: "1px solid lightGray", textAlign: "left" }}>
        <div style={{ textAlign: "left", fontSize: "14px", marginBottom: "5px", display: "inline", lineHeight: "32px" }}>Resolución 4K:</div>
        <span style={{ float: "right" }}>
          {resolucion4kCamara != null ? resolucion4kCamara ? <Chip label="Ok, perfecto." color="success" /> : <Chip label="Sin acceso" color="error" /> : <Chip label="?" color="warning" />}
        </span>
      </div>
      
      <Modal
        open={mostrarMensajeModal}
      >
        <Box sx={modalStyle}>
          <Typography id="modal-title" variant="h6" component="h2">
            Información
          </Typography>
          <Typography id="modal-description" sx={{ mt: 2 }}>
            {contenidoMensajeModal}
          </Typography>
          <div>
            <Button sx={{ mt: 2 }} onClick={cerrarModal}>
              Cerrar
            </Button>
            {mostrarBotonReintentarModal? <Button sx={{ mt: 2 }} onClick={init} >Reintentar</Button>: ""}
            {mostrarBotonContinuarModal? <Button sx={{ mt: 2 }} onClick={avanzar} >Continuar</Button>: ""}
          </div>
        </Box>
      </Modal>
    </div>
  );
});

export default Step4;